import { SidebarInset, SidebarProvider } from "../ui/sidebar";
import { AppSidebar } from "./Sidebar";
import { SiteHeader } from "./SiteHeader";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <SidebarProvider
        style={
          {
            "--sidebar-width": "calc(var(--spacing) * 72)",
            "--header-height": "calc(var(--spacing) * 12)",
          } as React.CSSProperties
        }
      >
        <AppSidebar variant="inset" />
        <SidebarInset>
          <SiteHeader />
          <main className="flex-1 @container/main">{children}</main>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
